document.addEventListener('click', function(event) {
// Check if the clicked element (or its parent) is a link with our specific hash
var link = event.target.closest('a[href*="#cookie-settings"]');
if (link) {
    event.preventDefault(); // Stop the browser from jumping to the top of the page
    // Trigger the Cookiebot preference center
    if (typeof Cookiebot !== 'undefined') {
    Cookiebot.renew();
    } else {
    console.warn('Cookiebot SDK is not loaded yet.');
    }
}
}, false);